import React from "react";
import { Box, TextField, Select, MenuItem, InputLabel, FormControl, Chip } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";

const FilterBar = ({ filters, setFilters, onFilterChange }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        gap: "15px",
        alignItems: "center",
        padding: "10px",
        borderRadius: "8px",
        mt: -2,
        mb: 2,
      }}
    >
      {/* ✅ حقل البحث عن العميل */}
      <TextField
        label="البحث عن العميل"
        variant="outlined"
        size="small"
        value={filters.search}
        onChange={(e) => {
          setFilters({ ...filters, search: e.target.value });
          onFilterChange({ ...filters, search: e.target.value }); // ✅ تصفية مباشرة
        }}
      />

      {/* ✅ تصفية حسب الحالة */}
      <FormControl size="small" sx={{ minWidth: 140 }}>
        <InputLabel>الحالة</InputLabel>
        <Select
          value={filters.status}
          onChange={(e) => {
            setFilters({ ...filters, status: e.target.value });
            onFilterChange({ ...filters, status: e.target.value }); // ✅ تصفية مباشرة
          }}
          label="الحالة"
        >
          <MenuItem value="">الكل</MenuItem>
          <MenuItem value="مفتوح">
            <Chip label="مفتوح" sx={{ bgcolor: "#4CAF50", color: "#fff" }} />
          </MenuItem>
          <MenuItem value="متاح">
            <Chip label="متاح" sx={{ bgcolor: "#03A9F4", color: "#fff" }} />
          </MenuItem>
          <MenuItem value="محجوز">
            <Chip
              label="محجوز"
              sx={{ bgcolor: "#F44336", color: "#fff" }}
              icon={<LockIcon sx={{ color: "#fff" }} />}
            />
          </MenuItem>
        </Select>
      </FormControl>

      {/* ✅ تصفية حسب اسم الكابتن */}
      <FormControl size="small" sx={{ minWidth: 140 }}>
        <InputLabel>الكابتن</InputLabel>
        <Select
          value={filters.captain}
          onChange={(e) => {
            setFilters({ ...filters, captain: e.target.value });
            onFilterChange({ ...filters, captain: e.target.value }); // ✅ تصفية مباشرة
          }}
          label="الكابتن"
        >
          <MenuItem value="">الكل</MenuItem>
          <MenuItem value="كريم">كريم</MenuItem>
          <MenuItem value="فهد">فهد</MenuItem>
          <MenuItem value="عمر">عمر</MenuItem>
          <MenuItem value="سعيد">سعيد</MenuItem>
          <MenuItem value="زياد">زياد</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default FilterBar;
